"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderNames = void 0;
var HeaderNames;
(function (HeaderNames) {
  HeaderNames["Parameters"] = "X-ExP-Parameters";
  HeaderNames["AssignmentScopes"] = "X-ExP-AssignmentScopes";
  HeaderNames["BlockedVariants"] = "X-ExP-BlockedVariants";
  HeaderNames["RequiredVariants"] = "X-ExP-RequiredVariants";
  HeaderNames["SdkVersion"] = "X-ExP-SDK-Version";
})(HeaderNames = exports.HeaderNames || (exports.HeaderNames = {}));